import 'tslib';
import 'long';
import '../../proto/index.js';
import { SdkConsts } from '../../core/consts.js';
import { Logger } from '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../manager/AdapterManager.js';
import '../manager/types.js';
import '../../core/utils/ticker.js';
import '../abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';
import { IMWebSocket } from '../abstract/IMWebSocket.js';

class BrowserWebSocket extends IMWebSocket {
    registerEvents() {
        this.ws.onclose = (e) => {
            this.onClose.next(e, this);
        };
        this.ws.onopen = () => {
            this.onOpen.nextEmpty(this);
        };
        this.ws.onmessage = (v) => {
            this.onMessage.next(v.data, this);
        };
        this.ws.onerror = (err) => {
            this.onError.next(err, this);
        };
    }
    open() {
        if (this.isOpen()) {
            Logger.ctxWarn(this.ctx, 'ws already open, close first');
            return Promise.resolve(true);
        }
        this.ws = new WebSocket(this.paramUrl, SdkConsts.wsProtocols);
        this.ws.binaryType = 'arraybuffer';
        this.registerEvents();
        let wsResolve;
        let wsReject;
        const sub = this.onOpen.subscribe(() => {
            wsResolve(true);
            this.onOpen.unsubscribe(sub);
        });
        const errConn = this.onError.subscribe((err) => {
            wsReject(err);
            this.onError.unsubscribe(errConn);
        });
        return new Promise((resolve, reject) => {
            wsResolve = resolve;
            wsReject = reject;
        });
    }
    close() {
        if (this.ws) {
            this.ws.onmessage = null;
            this.ws.close();
        }
        this.ws = undefined;
    }
    send(req) {
        this.ws.send(req);
    }
    isOpen() {
        return this.ws !== undefined && this.ws.readyState === WebSocket.OPEN;
    }
}

export { BrowserWebSocket };
//# sourceMappingURL=BrowserWebSocket.js.map
